<template>
  <div>
    <Row>
      <Column :md="6">
        <Field
          :label="$t('name')"
          required
          :value.sync="image.name" />
      </Column>
      <Column :md="3">
        <Field
          :label="$t('width')"
          type="number"
          :value.sync="image.width" />
      </Column>
      <Column :md="3">
        <Field
          :label="$t('height')"
          type="number"
          :value.sync="image.height" />
      </Column>
    </Row>
    <Row>
      <Column :md="6">
        <Row>
          <Column :md="6">
            <Field
              :label="$t('host')"
              required
              :value.sync="image.host" />
          </Column>
          <Column :md="6">
            <Field
              :label="$t('url')"
              required
              :value.sync="image.url" />
          </Column>
        </Row>
      </Column>
      <Column :md="6">
        <Field
          :label="$t('remoteMediaUrl')"
          :value.sync="image.remoteMediaUrl" />
      </Column>
    </Row>
    <Row>
      <Column :md="6">
        <Set icon="clock" :label="$t('createdAt')">
          {{ image.createdAt | relativeTime }}
        </Set>
      </Column>
      <Column :md="6">
        <Set icon="clock" :label="$t('updatedAt')">
          {{ image.updatedAt | relativeTime }}
        </Set>
      </Column>
    </Row>
  </div>
</template>

<script>
import Set from '@components/Set'

export default {
  components: {
    Set,
  },
  props: {
    image: Object,
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "createdAt": "Date created",
    "height": "Height",
    "host": "Host",
    "name": "Image name",
    "remoteMediaUrl": "Remote URL",
    "updatedAt": "Date updated",
    "url": "URL",
    "width": "Width"
  }
}
</i18n>
